var map = {
	"./index1-old.jpg": "177a",
	"./index1.jpg": "f6da",
	"./index2.jpg": "fd6c",
	"./index3.jpg": "b9de",
	"./index4.jpg": "2074",
	"./school1.jpg": "26a1",
	"./school2.jpg": "e7b3",
	"./school3.jpg": "8482"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d49a";